module.exports = __webpack_public_path__ + "static/media/bitbucket.9cc25ef4.png";